export const FETCH_CREATE_USER_REQUEST = 'FETCH_CREATE_USER_REQUEST'
export const FETCH_CREATE_USER_SUCCESS = 'FETCH_CREATE_USER_SUCCESS'
export const FETCH_CREATE_USER_FALUIRE = 'FETCH_CREATE_USER_FALUIRE'
